var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "error-layout" } }, [
    _c("div", { staticClass: "container" }, [
      _c("p", { staticClass: "headline-large gray" }, [
        _vm._v(_vm._s(_vm.$t("errorView.title"))),
      ]),
      _c("div", { staticClass: "container-img" }, [
        _c("img", {
          attrs: { src: require("@/assets/images/self-care/error.png") },
        }),
        _c("p", { staticClass: "text-medium gray mg mg--t-5" }, [
          _vm._v(_vm._s(_vm.$t("errorView.text"))),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }